import { layoutValues } from '../configs/options';
import { useSearchParams } from 'react-router-dom';
import { useActiveListOfOptionValues } from './useActiveListOfOptionValues';
export const useActiveListOfLayouts = (searchParams = useSearchParams()[0]) => {
    return useActiveListOfOptionValues(searchParams, ...layoutValues);
};
